import { userApis } from '../apis';

export const updateThemeIdAfterMigrateService = async ({ themeId }: { themeId: string }) => {
  return userApis.user.clientApi.updateThemeIdAfterMigrate({ themeId });
};
